module.exports = __webpack_public_path__ + "img/crusher.366f8cce.png";